import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { selectUserRole } from 'renderer/features/auth/state/userSelectors';
import { useAppSelector } from 'renderer/shared/state/hooks';

type ProtectedRoutesProps = {
  restrictTo: 'admin' | 'user';
};

const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ restrictTo }) => {
  const role = useAppSelector(selectUserRole);
  let isAuthorized = false;
  if (role === 'admin') isAuthorized = true;
  if (role === 'user' && restrictTo === 'user') isAuthorized = true;

  if (!isAuthorized) return <Navigate to="/login" />;
  return <Outlet />;
};

export default ProtectedRoutes;
